import React, { useState, useEffect } from "react";
import Input from '../components/Input'
import { Link } from 'react-router-dom'
import Button from '../components/Button'
import AccountLayout from '../layouts/AccountLayout'
import Alert from '../components/Alert';
import { useHistory } from "react-router-dom";
import useFormValidation from "../libs/validation/formvalidation";
// import authenticator from "../services/authenticateService";
import { usePost } from "../libs/service/api";
import ValidateAuth from "../libs/validation/login-validation";
import commonService from '../services/commonService';
import cookie from "../libs/cookie/client";

const Login = (props) => {
    const { toast, snackbar } = require('tailwind-toast')
    const history = useHistory();
    const userData = commonService.getUserData();
    const [isSending, setIsSending] = useState("")
    // const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [loginError, setLoginError] = useState(undefined)
    const INITIAL_STATE = {
        email: "",
        password: ""
    };

   

    const OnSuccess = () => {
        setIsSending(true)

        usePost('/api/auth/postlogin', { username: values.email, password: values.password }).then(res => {
            setIsSending(false);
            if (res.data == "Wrong username or password") {
                setLoginError(res.data)
            } else {
                setLoginError(false)
                res.email = values.email
                res.userid = res.userid
                res.username = res.name
                res.needsassesmentid = res.needsassesmentid
                res.authorizationKey = res.data
                //authenticator.login(res);
                cookie.setItem('authorizationKey', res.data);
                cookie.setItem('username', res.name);
                cookie.setItem('email', values.email);
                cookie.setItem('userid', res.userid);
                cookie.setItem('needsassesmentid', res.needsassesmentid);
                cookie.setItem('passwordexist', 1);
                // userData.username=res.name
                // userData.email=values.email
                // userData.userid=res.userid
                // commonService.setUserData(userData)
                toast().success('', 'Login Sucessfully').with({
                    shape: 'square',
                    duration: 2000,
                    speed: 200,
                    positionX: 'center',
                    positionY: 'top',
                    color: 'text-white bg-primary border-primary-dark border rounded-lg',
                    fontColor: 'white',
                    fontTone: 0
                }).show()
                if (res.needsassesmentid > 0) {
                    history.push(`/dashboard/` + res.needsassesmentid);
                   // history.push(`/dashboard/`);
                } else {
                    history.push(`/`);
                }
            }
            console.log("login")
            console.log(res)
            console.log(res.userid);
            console.log(res.needsassesmentid);
        });
    }

    // const forgotPasswordClick = () => {
    //     props.history.push('/dashboard/')
    // }

    const {
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
    } = useFormValidation(INITIAL_STATE, ValidateAuth, OnSuccess);

    // const isDisable = () => {
    //     return isSubmitting || isSending;
    // }

    useEffect(() => {
        if (cookie.getItem('authorizationKey') !== null || cookie.getItem('email') !== null) {
            history.push('/')
        }
    }, []);

    // useEffect(() => {
    //     if (authenticator.isLoggedIn()) {
    //         history.push('/')
    //     }
    //     setIsLoggedIn(authenticator.isLoggedIn())
    //     setIsSending(false)
    // }, []);


    return (
        <AccountLayout>
            {/* {errors && errors.email != undefined && <div>
                <Alert type="secondary" heading="Login mismatch" content={errors.email + "<br/>" + errors.password} isVisible={true} />
            </div>} */}
            {loginError &&
                <Alert type="secondary" heading="Login mismatch" content={loginError} isVisible={true} />
            }
            <div className="mb-4">Log in to continue:</div>
            <form className="account-form" onSubmit={handleSubmit}>
                <div className="mb-4">
                    <Input label="E-mail" type="email" placeholder="E-mail"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="email"
                        autoComplete="off"
                        defaultValue={values.email}
                        error={errors.email}
                        haserror={errors.email ? 1 : 0}
                    />
                </div>
                <div className="mb-4">
                    <Input label="Password" type="password" placeholder="*******"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.password}
                        name="password"
                        error={errors.password}
                        haserror={errors.password ? 1 : 0}
                    />
                </div>
                <Link to="/forgot-password/" className="font-semibold text-primary">Forgot Password</Link>
                <div className=" mt-10" role="group">
                    {!isSending && (
                        <button type="submit" onClick={props.onClick} className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4">
                            Login
                        </button>
                    )}
                    {isSending && (
                        <div className="col-3  flex justify-center item-center aheight items-center border-primary text-white font-semibold  text-base  rounded-full  border-2  active:border-3 disabled:opacity-50 focus:outline-none w-full mb-4" >
                            <div className="snippet py-1.5 px-8" data-title=".dot-pulse">
                                <div className="stage">
                                    <div className="dot-pulse"></div>
                                </div>
                            </div>
                        </div>
                    )}

                    <Button type="button" btnStyle="primary-outline" onClick={() => { history.push('/register/') }} text="Go to Account Creation" extraClasses="w-full" />
                </div>
            </form>
            <div className="flex justify-center border-t border-primary-light pt-4 mt-5">
                <Link to="/" className="text-primary font-semibold">Return to Home</Link>
            </div>
        </AccountLayout>
    )
}


export default Login

